<template>
  <div v-if="infoBoxes && infoBoxes.items?.length">
    <JoszakiHeading :level="2" class="text-center">
      {{ infoBoxes.title }}
    </JoszakiHeading>
    <div class="flex flex-wrap justify-center gap-4">
      <JoszakiCard
        v-for="(infoBox, index) in infoBoxes.items"
        :key="index"
        class="flex flex-col items-center gap-2 w-full md:w-[calc(50%-0.5rem)] lg:w-[calc(33.333%-0.667rem)]"
        hoverable
      >
        <div
          class="w-10 h-10 bg-primary-lightest rounded-full flex items-center justify-center"
        >
          <IconComponent
            :icon="infoBox.icon"
            :pack="infoBox.pack"
            class="w-5 h-5 text-primary"
          />
        </div>
        <p class="font-bold text-center">
          {{ infoBox.title }}
        </p>
        <p class="text-gray-500 text-sm text-center">
          {{ infoBox.description }}
        </p>
      </JoszakiCard>
    </div>
  </div>
</template>

<script>
import { computed } from "@nuxtjs/composition-api";

export default {
  name: "ServiceTypeInfoBoxes",
  props: {
    serviceType: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const infoBoxes = computed(() => props.serviceType?.options?.infoBoxes);

    return {
      infoBoxes,
    };
  },
};
</script>
